import {
  BindField,
  BindTypeField,
  GANTT_BIND_TYPE_LIST,
  GanttFormValues,
  GanttFormValuesBack,
} from '@gantt/components/GanttCreateOrEdit/types'

export const prepareConfigData = (config: GanttFormValuesBack): GanttFormValues => {
  const data = structuredClone(config)

  function resetEmptyFields(item: Record<string, any>) {
    for (const property in item) {
      if (property === 'isNew') {
        delete item[property]
      }

      if (
        item[property]?.bindType === GANTT_BIND_TYPE_LIST.FIELD &&
        !item[property]?.field?.pathStr
      ) {
        item[property].field = undefined
      } else if (item[property]?.bindType === GANTT_BIND_TYPE_LIST.FIELD_ARRAY) {
        item[property].field_array = item[property]?.field_array?.filter(
          (item: BindTypeField) => item.field
        )
      } else {
        if (Array.isArray(item[property])) {
          item[property].map((item: BindField) => {
            resetEmptyFields(item)
          })
        }
      }
    }
  }

  resetEmptyFields(data)

  return data as unknown as GanttFormValues
}
